<template>
  <div class="sidebar sidebar-dark sidebar-main sidebar-expand-lg">
    <div class="text-end my-1 me-3">
      <button
        type="button"
        class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent sidebar-mobile-main-toggle d-lg-none"
        title="Ocultar"
      >
        <i class="ph-x"></i>
      </button>
    </div>
    <LoadingData v-if="!progressCourse.course" />
    <div v-else class="sidebar-content">
      <div class="sidebar-section">
        <div
          class="sidebar-section-body d-flex justify-content-center"
          :title="progressCourse.course.description"
        >
          <h6
            class="sidebar-resize-hide flex-grow-1 my-auto text-center cursor-pointer"
            @click="setShowDetailsCourse()"
          >
            {{ progressCourse.course.name }}
          </h6>
        </div>
        <div class="progress mx-3 mb-3" style="height: 0.875rem">
          <div
            class="progress-bar bg-info"
            :style="`width: ${progressCourse.course.percentageCompleted}%`"
          >
            <span>{{ progressCourse.course.percentageCompleted }}%</span>
          </div>
        </div>
      </div>
      <div class="sidebar-section">
        <ul
          v-if="
            progressCourse.course &&
            progressCourse.course.modules &&
            progressCourse.course.modules.length > 0
          "
          class="nav nav-sidebar"
          data-nav-type="accordion"
        >
          <li class="nav-item-header pt-0">
            <div
              class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
            >
              Módulos
            </div>
            <i class="ph-dots-three sidebar-resize-show"></i>
          </li>
          <li
            v-for="module in progressCourse.course.modules"
            :key="module.id"
            class="nav-item nav-item-submenu"
            :class="{
              'nav-item-open': progressCourse.moduleSelected == module.id,
            }"
            @click="setModuleSelected(module.id)"
          >
            <a
              href="#"
              class="nav-link d-flex align-items-center"
              :title="module.description"
            >
              <RadialProgressBar
                class="fs-sm"
                :diameter="50"
                :startColor="'#25b372'"
                :stopColor="'#25b372'"
                :strokeWidth="3"
                :innerStrokeWidth="3"
                :completed-steps="module.percentageCompleted"
                :total-steps="100"
              >
                <small>{{ module.percentageCompleted }}%</small>
              </RadialProgressBar>
              <span class="ms-2">{{ module.name }}</span>
            </a>
            <ul
              v-if="module.lessons && module.lessons.length > 0"
              class="nav-group-sub collapse"
              :class="{
                'd-block': progressCourse.moduleSelected == module.id,
              }"
            >
              <li
                v-for="lesson in module.lessons"
                :key="lesson.id"
                class="nav-item"
                :title="lesson.description"
              >
                <a
                  class="nav-link cursor-pointer align-items-center"
                  :class="{
                    active: progressCourse.lessonSelected === lesson.id,
                  }"
                  @click.stop.prevent="setLessonSelected(lesson.id)"
                >
                  <i
                    :class="{
                      'ph-monitor-play': lesson.type === '1',
                      'ph-list-bullets': lesson.type === '2',
                      'ph-file-text': lesson.type === '3',
                      'text-success': lesson.done === '1',
                    }"
                  />
                  <span class="text-wrap fs-sm">{{ lesson.title }}</span>
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item-header">
            <div
              class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
            >
              Prova Final
            </div>
            <i class="ph-dots-three sidebar-resize-show"></i>
          </li>
          <li class="nav-item">
            <a
              v-if="progressCourse.course.showTest"
              class="nav-link d-flex align-items-center cursor-pointer"
              :class="{ active: progressCourse.testSelected }"
              title="Acessar"
              @click="setTestSelected()"
            >
              <i
                class="ph-file-text"
                :class="{
                  'text-success': progressCourse.course.showCertificate,
                }"
              />
              <span class="fs-sm">Acessar</span>
            </a>
            <a
              v-else
              class="nav-link d-flex align-items-center disabled"
              title="Para realizar a prova final é necessário concluir todas as aulas"
            >
              <i class="ph-file-text" />
              <span class="fs-sm">Acessar</span>
            </a>
          </li>
          <li class="nav-item-header">
            <div
              class="text-uppercase fs-sm lh-sm opacity-50 sidebar-resize-hide"
            >
              Certificado
            </div>
            <i class="ph-dots-three sidebar-resize-show"></i>
          </li>
          <li class="nav-item">
            <a
              v-if="progressCourse.course.showCertificate"
              class="nav-link d-flex align-items-center cursor-pointer"
              :class="{ active: progressCourse.certificateSelected }"
              title="Acessar Certificado"
              @click="setCertificateSelected()"
            >
              <i
                class="ph-file-text"
                :class="{
                  'text-success': progressCourse.course.showCertificate,
                }"
              />
              <span class="fs-sm">Acessar</span>
            </a>
            <a
              v-else
              class="nav-link d-flex align-items-center disabled"
              title="Para gerar o certificado é necessário fazer a prova final"
            >
              <i class="ph-file-text" />
              <span class="fs-sm">Acessar</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import RadialProgressBar from 'vue3-radial-progress'
import { mapGetters } from 'vuex'

export default {
  name: 'Sidebar',

  components: {
    LoadingData,
    RadialProgressBar,
  },

  computed: {
    ...mapGetters(['progressCourse', 'reloadProgressCourse']),
  },

  watch: {
    reloadProgressCourse: {
      handler(newVal, oldVal) {
        if (newVal === true) {
          this.getProgressCourse()
          this.$store.dispatch('setReloadProgressCourse', false)
        }
      },
      immediate: true,
    },
  },

  methods: {
    // Initialize all sidebars
    initSidebars() {
      this.sidebarMainToggle()
      this.sidebarComponentToggle()
    },

    // Initialize all navigations
    initNavigations() {
      this.navigationSidebar()
    },

    // Toggle main sidebar
    sidebarMainToggle() {
      // Elements
      const sidebarMainElement = document.querySelector('.sidebar-main')
      const sidebarMainRestElements = document.querySelectorAll(
        '.sidebar:not(.sidebar-main):not(.sidebar-component)',
      )
      const sidebarMainDesktopToggler = document.querySelectorAll(
        '.sidebar-main-toggle',
      )
      const sidebarMainMobileToggler = document.querySelectorAll(
        '.sidebar-mobile-main-toggle',
      )
      const sidebarCollapsedClass = 'sidebar-collapsed'
      const sidebarMobileExpandedClass = 'sidebar-mobile-expanded'

      // On desktop
      sidebarMainDesktopToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault()
          sidebarMainElement.classList.toggle(sidebarCollapsedClass)
        })
      })

      // On mobile
      sidebarMainMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault()
          sidebarMainElement.classList.toggle(sidebarMobileExpandedClass)

          sidebarMainRestElements.forEach(function (sidebars) {
            sidebars.classList.remove(sidebarMobileExpandedClass)
          })
        })
      })
    },

    // Toggle component sidebar
    sidebarComponentToggle() {
      // Elements
      const sidebarComponentElement =
        document.querySelector('.sidebar-component')
      const sidebarComponentMobileToggler = document.querySelectorAll(
        '.sidebar-mobile-component-toggle',
      )
      const sidebarMobileExpandedClass = 'sidebar-mobile-expanded'

      // Toggle classes
      sidebarComponentMobileToggler.forEach(function (toggler) {
        toggler.addEventListener('click', function (e) {
          e.preventDefault()
          sidebarComponentElement.classList.toggle(sidebarMobileExpandedClass)
        })
      })
    },

    // Sidebar navigation
    navigationSidebar() {
      // Elements
      const navContainerClass = 'nav-sidebar'
      const navItemOpenClass = 'nav-item-open'
      const navLinkClass = 'nav-link'
      const navLinkDisabledClass = 'disabled'
      const navSubmenuContainerClass = 'nav-item-submenu'
      const navSubmenuClass = 'nav-group-sub'
      const navScrollSpyClass = 'nav-scrollspy'
      const sidebarNavElement = document.querySelectorAll(
        `.${navContainerClass}:not(.${navScrollSpyClass})`,
      )

      // Setup
      sidebarNavElement.forEach(function (nav) {
        nav
          .querySelectorAll(
            `.${navSubmenuContainerClass} > .${navLinkClass}:not(.${navLinkDisabledClass})`,
          )
          .forEach(function (link) {
            link.addEventListener('click', function (e) {
              e.preventDefault()
              const submenuContainer = link.closest(
                `.${navSubmenuContainerClass}`,
              )
              const submenu = link
                .closest(`.${navSubmenuContainerClass}`)
                .querySelector(`:scope > .${navSubmenuClass}`)

              // Collapsible
              if (submenuContainer.classList.contains(navItemOpenClass)) {
                // eslint-disable-next-line no-undef
                new bootstrap.Collapse(submenu).hide()
                submenuContainer.classList.remove(navItemOpenClass)
              } else {
                // eslint-disable-next-line no-undef
                new bootstrap.Collapse(submenu).show()
                submenuContainer.classList.add(navItemOpenClass)
              }

              // Accordion
              if (
                link
                  .closest(`.${navContainerClass}`)
                  .getAttribute('data-nav-type') === 'accordion'
              ) {
                // eslint-disable-next-line no-restricted-syntax
                for (const sibling of link.parentNode.parentNode.children) {
                  if (
                    sibling !== link.parentNode &&
                    sibling.classList.contains(navItemOpenClass)
                  ) {
                    sibling
                      .querySelectorAll(`:scope > .${navSubmenuClass}`)
                      // eslint-disable-next-line no-loop-func, no-shadow
                      .forEach(function (submenu) {
                        // eslint-disable-next-line no-undef
                        new bootstrap.Collapse(submenu).hide()
                        sibling.classList.remove(navItemOpenClass)
                      })
                  }
                }
              }
            })
          })
      })
    },

    async getProgressCourse() {
      try {
        const course = await this.$store.dispatch(
          'getProgressCourse',
          this.progressCourse.course.id,
        )

        this.$store.dispatch('setProgressCourse', {
          ...this.progressCourse,
          course,
        })
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    setShowDetailsCourse() {
      this.$store.dispatch('setProgressCourse', {
        ...this.progressCourse,
        showDetailsCourse: true,
        moduleSelected: null,
        lessonSelected: null,
        testSelected: false,
        certificateSelected: false,
      })
    },

    setModuleSelected(moduleId) {
      if (this.progressCourse.moduleSelected === moduleId) {
        this.$store.dispatch('setProgressCourse', {
          ...this.progressCourse,
          moduleSelected: null,
        })
      } else {
        this.$store.dispatch('setProgressCourse', {
          ...this.progressCourse,
          moduleSelected: moduleId,
        })
      }
    },

    setLessonSelected(lessonId) {
      this.$store.dispatch('setProgressCourse', {
        ...this.progressCourse,
        showDetailsCourse: false,
        lessonSelected: lessonId,
        testSelected: false,
        certificateSelected: false,
      })
    },

    setTestSelected() {
      this.$store.dispatch('setProgressCourse', {
        ...this.progressCourse,
        showDetailsCourse: false,
        moduleSelected: null,
        lessonSelected: null,
        testSelected: true,
        certificateSelected: false,
      })
    },

    setCertificateSelected() {
      this.$store.dispatch('setProgressCourse', {
        ...this.progressCourse,
        showDetailsCourse: false,
        moduleSelected: null,
        lessonSelected: null,
        testSelected: false,
        certificateSelected: true,
      })
    },
  },

  mounted() {
    this.initSidebars()
    this.initNavigations()
  },
}
</script>

<style scoped>
.nav-group-sub .nav-link,
.nav-item:not(.nav-item-submenu) .nav-link {
  padding: 0.625rem 1.25rem 0.625rem 2rem;
}

.nav-item-submenu > .nav-link:after {
  top: auto;
}

.nav-link.disabled {
  pointer-events: initial;
}
</style>
